var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VIcon',{staticStyle:{"font-size":"1rem","vertical-align":"baseline"},attrs:{"title":_vm.$t('lock')}},[_vm._v(" mdi-lock ")])}
var staticRenderFns = []

export { render, staticRenderFns }